export default {
  Required: 'Fältet får inte vara tomt',
  Email: 'Felaktig e-postadress',
  MismatchingPasswords: 'Lösenord och upprepa lösenord stämmer inte överens',
  Password: 'Lösenordet måste vara minst 8 tecken långt',
  Company :'Du måste ange vilket företag och arbetsplats du arbetar på.',
  Sector:'Du måste ange vilken bransch du jobbar i.',
};
